/**
 * Search form
 */

(() => {

    const ajaxSearchGetParentWithClass = (el, cssClass) => {

        var ancestor = el.parentElement;
        while (ancestor.parentElement && ancestor.classList) {
            if (ancestor.classList.contains(cssClass)) {
                return ancestor;
            }
            ancestor = ancestor.parentElement;
        }
        return false;

    }

    const ajaxSearchRun = (query, searchResults, searchInput, searchForm, url) => {

        searchResults.classList.add('is-open');
        searchResults.innerHTML = '';

        if (query.length > 2) {
            searchResults.innerHTML = '';
            var loading = document.createElement('div');
            var loadingSpinner = document.createElement('div');
            var loadingLabel = document.createElement('p');
            loading.classList.add('ajax-search-results__loading');
            loadingSpinner.classList.add('ajax-search-results__loading__spinner');
            loadingLabel.classList.add('ajax-search-results__loading__label');
            loadingLabel.setAttribute('role', 'status');
            loadingLabel.setAttribute('aria-live', 'polite');
            loadingLabel.innerText = searchForm.getAttribute('data-loading');
            loading.appendChild(loadingSpinner);
            loading.appendChild(loadingLabel);
            searchResults.appendChild(loading);
        } else {
            searchResults.innerHTML = '';
            var pending = document.createElement('p');
            pending.classList.add('ajax-search-results__error');
            pending.setAttribute('role', 'status');
            pending.setAttribute('aria-live', 'polite');
            pending.innerText = searchForm.getAttribute('data-pending');
            searchResults.appendChild(pending);
            return;
        }


        fetch(url, {
                method: 'GET',
                credentials: 'include'
            })
            .then((response) => response.json())
            .then((json) => {

                if (json.html) {
                    searchResults.innerHTML = json.html;
                } else {
                    searchResults.innerHTML = '';
                    var error = document.createElement('p');
                    error.classList.add('ajax-search-results__error');
                    error.innerText = searchForm.getAttribute('data-error');
                    error.setAttribute('role', 'status');
                    error.setAttribute('aria-live', 'polite');
                    searchResults.appendChild(error);
                }

                ajaxSearchArrowKeyNavigation(searchResults);

            }).catch(() => {
                searchResults.innerHTML = '';
                var error = document.createElement('p');
                error.classList.add('ajax-search-results__error');
                error.innerText = searchForm.getAttribute('data-error');
                error.setAttribute('role', 'status');
                error.setAttribute('aria-live', 'polite');
                searchResults.appendChild(error);
            });;
    }

    const searchForms = document.querySelectorAll('.js-ajax-search-form');

    for (var i = 0; i < searchForms.length; i++) {

        var searchInput = searchForms[i].querySelector('[type="search"]');
        var searchResults = searchForms[i].querySelector('.js-ajax-search-form-results');

        if (!searchInput || !searchResults) {
            console.error('Ajax Search Form: Invalid HTML');
            return;
        }

        /**
         * Keydown => go to results
         */
        searchInput.addEventListener('keydown', (e) => {
            if (e.key == 'Down' || e.key == 'ArrowDown') {
                e.preventDefault();
                const form = ajaxSearchGetParentWithClass(e.currentTarget, 'js-ajax-search-form');
                if (form) {
                    const searchResults = form.querySelector('.js-ajax-search-form-results');
                    if (searchResults && searchResults.querySelector('a')) {
                        searchResults.querySelector('a').focus();
                    }
                }
            }
        });

        /**
         * Run ajax on keyup
         */
        searchInput.addEventListener('keyup', (e) => {

            var searchInput = e.currentTarget;
            const form = ajaxSearchGetParentWithClass(e.currentTarget, 'js-ajax-search-form');

            if (form) {

                const searchResults = form.querySelector('.js-ajax-search-form-results');

                let url = form.action;
                url += '?ajax_search_s=' + encodeURIComponent(searchInput.value);

                const oldQueryLength = form.getAttribute('data-query-length');
                if (parseInt(oldQueryLength) !== parseInt(searchInput.value.length)) {
                    ajaxSearchRun(searchInput.value, searchResults, searchInput, form, url);
                }
                form.setAttribute('data-query-length', searchInput.value.length);

                if (searchInput.value.length == 0) {
                    searchResults.classList.remove('is-open');
                }

            }

        });

    }

    /**
     * Hook arrow navigation (up/down) to results
     */
    const ajaxSearchArrowKeyNavigation = (searchResults) => {

        const links = searchResults.querySelectorAll('a');
        for (var i = 0; i < links.length; i++) {
            links[i].addEventListener('keydown', (e) => {
                const form = ajaxSearchGetParentWithClass(e.currentTarget, 'js-ajax-search-form');
                const searchResults = form.querySelector('.js-ajax-search-form-results');
                const links = searchResults.querySelectorAll('a');
                if (links.length) {
                    const firstLink = links[0];
                    const lastLink = links[links.length - 1];
                    let currentLinkIndex = 0;
                    for (var j = 0; j < links.length; j++) {
                        if (links[j].isEqualNode(e.currentTarget)) {
                            currentLinkIndex = j;
                            break;
                        }
                    }
                    if (e.key == 'Down' || e.key == 'ArrowDown') {
                        if (links[currentLinkIndex + 1]) {
                            links[currentLinkIndex + 1].focus();
                        } else {
                            firstLink.focus();
                        }
                        e.preventDefault();
                        e.stopPropagation();
                    } else if (e.key == 'Up' || e.key == 'ArrowUp') {
                        if (links[currentLinkIndex - 1]) {
                            links[currentLinkIndex - 1].focus();
                        } else {
                            lastLink.focus();
                        }
                        e.preventDefault();
                        e.stopPropagation();
                    }
                }
            });
        }

    }

    /**
     * Bail on ESC key
     */
    window.addEventListener('keydown', (e) => {

        if (e.key == 'Esc' || e.key == 'Escape') {

            var searchResults = searchResults.querySelectorAll('.js-ajax-search-form-results');
            for (var i = 0; i < searchResults.length; i++) {
                searchResults.classList.remove('is-open');
            }

        }

    });

    /**
     * Bail on outside click
     */
    document.addEventListener('click', (e) => {
        const form = ajaxSearchGetParentWithClass(e.target, 'js-ajax-search-form');
        if (!form) {
            var searchResults = document.querySelectorAll('.js-ajax-search-form-results');
            for (var i = 0; i < searchResults.length; i++) {
                searchResults[i].classList.remove('is-open');
            }
        }
    });
})();